// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0f19683d","488":"14748e94"}[chunkId] + ".chunk.js";
};